var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBankImg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4957_81158)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.3941 5.09268L34.4416 12.0899H5.5603L19.6079 5.09268C19.8551 4.96911 20.1469 4.96911 20.3941 5.09268ZM6.90237 17.1045C7.06737 17.2702 7.297 17.3633 7.52411 17.3633L7.52452 17.3632C7.52463 17.3632 7.52481 17.3633 7.52493 17.3627H32.4751C32.4752 17.3632 32.4754 17.3632 32.4755 17.3632L32.4755 17.3632L32.4759 17.3633C32.7031 17.3633 32.9327 17.2702 33.0977 17.1045C33.2765 16.9257 34.613 15.5338 35 13.8477H5C5.38701 15.5338 6.72348 16.9257 6.90237 17.1045ZM13.8477 19.1211H8.51564V29.7267H13.8477V19.1211ZM5.87904 35C5.59064 35 5.32116 34.8584 5.15722 34.6224C4.99239 34.3855 4.95466 34.0834 5.05591 33.813C5.39839 32.8972 6.0387 32.0938 6.29874 31.7917C6.46527 31.5969 6.70902 31.4845 6.96566 31.4845H33.0344C33.2911 31.4845 33.5348 31.5969 33.7013 31.7917C33.9614 32.0938 34.6017 32.8972 34.9442 33.813C35.0454 34.0834 35.0076 34.3855 34.8428 34.6224C34.6789 34.8584 34.4094 35 34.121 35H5.87904ZM17.3633 19.1211H22.6368V29.7267H17.3633V19.1211ZM31.4845 19.1211H26.1524V29.7267H31.4845V19.1211Z",
    fill: "#717171"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4957_81158"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBankImg);
export default __webpack_public_path__ + "static/media/bank-img.bc6cfe8131159248e5be8af8c664e1c7.svg";
export { ForwardRef as ReactComponent };